import { useEffect } from "react";
import AppLayout from "../components/common/AppLayout";
import FiltroReporte from "../components/reportes/FiltroReporte";
import ExportButtons from "../components/reportes/ExportButtons";
import ReporteCard from "../components/reportes/ReporteCard";
import useReportes from "../hooks/useReportes";

export default function ReportesPage() {
    const { filtros, setFiltros, data, loading, cargar } = useReportes();

    useEffect(() => {
        cargar();
    }, [cargar]);

    return (
        <AppLayout title="Reportes">
            <FiltroReporte
                filtros={filtros}
                setFiltros={setFiltros}
                onBuscar={cargar}
            />

            <ExportButtons onExcel={() => {}} onPdf={() => {}} />

            {loading ? (
                <p>Cargando reportes...</p>
            ) : (
                <div className="dashboard-panels">
                    <ReporteCard title="Flujo de caja">
                        <pre>{JSON.stringify(data.flujoCaja, null, 2)}</pre>
                    </ReporteCard>

                    <ReporteCard title="Ingresos por fuente">
                        <pre>{JSON.stringify(data.ingresosFuente, null, 2)}</pre>
                    </ReporteCard>

                    <ReporteCard title="Gastos por categoría">
                        <pre>{JSON.stringify(data.gastosCategoria, null, 2)}</pre>
                    </ReporteCard>

                    <ReporteCard title="Presupuesto vs real">
                        <pre>{JSON.stringify(data.presupuestoVsReal, null, 2)}</pre>
                    </ReporteCard>
                </div>
            )}
        </AppLayout>
    );
}